module.exports = __webpack_public_path__ + "static/media/Tied in Knots - VISAP2020.b14af5d1.pdf";